import React, { useRef, useState, useCallback } from "react";
import { FiLoader } from "react-icons/fi";
import ModalEmail from "react-modal";
import * as Yup from "yup";
import { Form } from "@unform/web";

import { Input } from "../Forms";

import axios from "../../services/axios";

import { ModalContent, overlayStyle, contentStyle, Wrap, Button } from "./styles.js";

import closeButton from "../../images/modal/close.svg";

export default function Modal() {
  const [open, setOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const formRef = useRef();

  const handleCloseModal = useCallback(() => {
    setOpen(false);
  }, []);

  function handleChange(event) {
    const { name, value } = event.target;
    setFormData((state) => ({ ...state, [name]: value }));
  }

  async function handleSubmit() {
    try {
      setLoading(true);
      formRef.current.setErrors({});
      let response = [];

      const schema = Yup.object().shape({
        email: Yup.string()
          .email("Invalid E-mail")
          .required("Write your e-mail address"),
      });

      await schema.validate(formData, {
        abortEarly: false,
      });

      response = await axios.post("email-marketing", {
        email: formData.email,
      });

      setLoading(false);
      handleCloseModal();
    } catch (err) {
      setLoading(false);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message;
        });
        formRef.current.setErrors(validationErrors);
      }
    }
  }
    
  return (
    <ModalEmail
      className="TesteModal"
      onRequestClose={handleCloseModal}
      ariaHideApp={false}
      isOpen={open}
      style={{
        overlay: overlayStyle,
        content: contentStyle,
      }}>
      <ModalContent>
        <img onClick={handleCloseModal} className="close" src={closeButton} alt="Close Button" />
        <h2>Register your email and receive 5% discount on your estimate!</h2>
        {formData && (
            <Form ref={formRef} onSubmit={handleSubmit}>
              <Wrap>
                <Input
                  name="email"
                  placeholder="E-mail"
                  onChange={handleChange}
                  value={formData.email}
                />
              </Wrap>
              <Button type="submit">
                {loading ? (
                  <FiLoader size={20} className="icon-spin" />
                ) : (
                  "SEND"
                )}
              </Button>
            </Form>
          )
        }        
      </ModalContent>
    </ModalEmail>
  )
}